export default __webpack_public_path__ + "static/media/img-28.6bed132e.jpg";